if (typeof $ == 'undefined') {
    //load jquery from cdn then excecute collectionTabsJS
    var script = document.createElement('script');
    script.src = "https://code.jquery.com/jquery-3.4.1.min.js";
    script.onload = function () {
        productJS();
    };
    document.head.appendChild(script);
} else {
    productJS();
}
function productJS(){
  console.log($(".productVariantSwatch"));
  
  //Variant selector
  $(".productVariantSwatch").on("change", function(){
    let target = '';
    let comparePrice = false;
    $('variant-radios').find('input[type="radio"]:checked').each(function(){
      const $this = $(this);
      const dataPosition = $this.data('option');
      const thisValue = $this.val();
      target += `[data-option-${dataPosition}="${thisValue}"]`
    })
    if($(target).length === 1){
      $(".productVariantHiddenSelect").val($(target).attr("value"));
      comparePrice = $(target).attr("data-compare-price");
      const url = new URL(window.location.href);
      url.searchParams.set('variant', $(target).attr("value"));
      window.history.replaceState(null, null, url);
    }
    pdpChangePrice(comparePrice);
  });

  //subscribe select
  waitForElm('.rc-radio__input').then((elm) => {
    setTimeout(function(){
      setTimeout(function() {
        let updatedPrice = $(".current_price.showPriceHere").text().trim();
        if(updatedPrice != pdpCurrentPrice) {
          $(".current_price.showPriceHere").prepend("<del class='pdpOldPrice'>"+pdpCurrentPrice+"</del>");
        }
      });
      $(".rc-radio__input").on("change", function() {
        let target = '';
        let comparePrice = false;
        $('variant-radios').find('input[type="radio"]:checked').each(function(){
          const $this = $(this);
          const dataPosition = $this.data('option');
          const thisValue = $this.val();
          target += `[data-option-${dataPosition}="${thisValue}"]`
        })
        if($(target).length === 1){
          comparePrice = $(target).attr("data-compare-price");
        }
        pdpChangePrice(comparePrice);
      });
    },300);
  });
}

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }
    });

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

function pdpChangePrice(comparePrice) {
  setTimeout(function() {
    if($(".rc_widget__option.rc-option--active").hasClass("rc-option__subsave")) {
      let pdpCurrentPrice1 = $(".rc_widget__option:not(.rc-option--active)").find(".rc-option__price").text();
      let newPrice = $(".rc_widget__option.rc-option--active").find(".rc-option__price").text();
      if(comparePrice) {
        pdpCurrentPrice1 = comparePrice;
      }
      if(hasUSD) {
        pdpCurrentPrice1 = pdpCurrentPrice1+" USD";
        newPrice = newPrice+" USD";
      }
      $(".showPriceHere").html("<del class='pdpOldPrice'>"+pdpCurrentPrice1+"</del>"+newPrice);
    } else {
      let pdpCurrentPrice1 = $(".rc_widget__option:not(.rc-option--active)").find(".rc-option__price").text();
      let newPrice = $(".rc_widget__option.rc-option--active").find(".rc-option__price").text();
      if(hasUSD) {
        newPrice = newPrice+" USD";
      }
      if(comparePrice) {
        if(hasUSD) {
          comparePrice = comparePrice+" USD";
        }
        $(".showPriceHere").html("<del class='pdpOldPrice'>"+comparePrice+"</del>"+newPrice);
      } else {
        $(".showPriceHere").html(newPrice);
      }
    }
  },100);
}